import { lazy } from "react";
import RouteGuard from "../routerPermission";

const VariantsPage = lazy(() => import("@/widgets/catalog/variants/VariantsPage"));

// Variants are product sub-resources — managing variant presets/options
// changes catalog behaviour, so the page gates on product:update. Without
// this guard the page was reachable by any signed-in staff member.
const variantRoute = {
  path: "variants",
  element: (
    <RouteGuard resource="product" action="update">
      <VariantsPage />
    </RouteGuard>
  ),
};

export default variantRoute;
